import * as React from "react";
import {Button} from "../Button/Button";
import {Headings} from "../Headings/Headings";
import "./Filters.scss";

export const CollectionFilter = ({ title, filters }) => {
    return (
        <div className={'collection-filters'}>
            <Headings text= {title} type={'h2'}/>
            <div className={`collection-filters__container`}>
                {filters.map((filter, index) => (
                    <a className={`collection-filters__item`} key={`buttonlink-${index}`} href={filter.settings.url}>
                        <Button label={filter.settings.title} key={index}/>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default CollectionFilter;